// extracted by mini-css-extract-plugin
export default {"wineChip":"wineChip--XqVAz","wineAvatar":"wineAvatar--W3YCo"};